export default __webpack_public_path__ + "static/media/more.55bcb426.svg";